// src/actions/paymentActions.js

import axios from 'axios';
import { serviceUrl } from './types';
export const createRazorpayOrder = (orderData) => async (dispatch) => {
    const loginDataString = localStorage.getItem('loginData');

    if (!loginDataString) {
        const error = new Error('You are not logged in. Please log in to make a payment.');
        error.code = 'AUTH_REQUIRED';
        throw error;
    }

    try {
        const loginData = JSON.parse(loginDataString);
        const token = loginData?.token;

        if (!token) {
            const error = new Error('Your authentication token is missing. Please log in again.');
            error.code = 'TOKEN_MISSING';
            throw error;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            timeout: 10000 // Add timeout
        };

        const res = await axios.post(
            `${serviceUrl}/api/appointmentPayments/paymentorder`, 
            orderData,
            config
        );

        return res.data;

    } catch (error) {
        // Handle specific error types
        if (error.code === 'AUTH_REQUIRED' || error.code === 'TOKEN_MISSING') {
            throw error; // Re-throw auth errors
        }

        if (error.response) {
            // Server responded with error status
            const status = error.response.status;
            const serverMessage = error.response.data?.message;
            
            if (status === 401 || status === 403) {
                const authError = new Error('Authentication failed. Your session may have expired. Please log in again.');
                authError.code = 'SESSION_EXPIRED';
                throw authError;
            } else if (status >= 500) {
                const serverError = new Error('Payment service is temporarily unavailable. Please try again later.');
                serverError.code = 'SERVER_ERROR';
                throw serverError;
            } else {
                throw new Error(serverMessage || 'Payment request failed.');
            }
        } else if (error.request) {
            // Request made but no response received
            const networkError = new Error('Network error. Please check your connection and try again.');
            networkError.code = 'NETWORK_ERROR';
            throw networkError;
        } else if (error.code === 'ECONNABORTED') {
            // Timeout error
            const timeoutError = new Error('Request timeout. Please try again.');
            timeoutError.code = 'TIMEOUT';
            throw timeoutError;
        } else {
            // Other errors
            throw new Error('An unexpected error occurred.');
        }
    }
};